import axios from '@/axios.js'

export default {
    getGeofences: async (appUuid, params) => {
        try {
            const response = await axios.editorapi.get(`v4/geofences/apps/${appUuid}`, { params })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    getGeofence: async (appUuid, geofenceUuid) => {
        try {
            const response = await axios.editorapi.get(`v4/geofences/apps/${appUuid}/${geofenceUuid}`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    deleteGeofence: async (appUuid, geofenceUuid) => {
        try {
            const response = await axios.editorapi.delete(`v4/geofences/apps/${appUuid}/${geofenceUuid}`)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    createGeofence: async (appUuid, payload) => {
        try {
            const response = await axios.editorapi.post(`v4/geofences/apps/${appUuid}/`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    updateGeofence: async (appUuid, geofenceUuid, payload) => {
        try {
            const response = await axios.editorapi.patch(`v4/geofences/apps/${appUuid}/${geofenceUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
}